import React from "react";
import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { format } from "date-fns";
import { Modal, Table } from "components";
import { casesActions } from "configs";
import { useCurrentCase, useDispatch, useParams } from "duck";
import { useUpdatePatientProcedureMutation } from "requests";
import { Create, Doctors, Timer } from "./components";

const MonitoringBy = () => {
  const dispatch = useDispatch();
  const { id: caseId } = useParams();
  const { shouldSync, patientId, procedures } = useCurrentCase(medicalCase => ({
    shouldSync: medicalCase.shouldSync,
    patientId: medicalCase.data.client.patient._id,
    procedures: medicalCase.data.client?.patient?.patientProcedures
  }));

  const [updateProcedure] = useUpdatePatientProcedureMutation({
    ignoreResults: true
  });

  const handleTimer = (
    startTime: Date | null,
    endTime: Date | null,
    id: number | string
  ) => {
    dispatch(
      casesActions.updatePatientProcedure({
        data: {
          ...(typeof id === "number" ? { _id: id } : { fakeId: id }),
          ...(startTime && { startTime: startTime.toISOString() }),
          ...(endTime && { endTime: endTime.toISOString() })
        },
        _id: caseId
      })
    );

    if (shouldSync) {
      return updateProcedure({
        variables: {
          input: {
            _id: id as number,
            ...(startTime && { startTime: startTime.toISOString() }),
            ...(endTime && { endTime: endTime.toISOString() })
          }
        }
      });
    }
  };

  if (!procedures) {
    return null;
  }

  return (
    <Box>
      <Flex justifyContent="space-between" alignItems="center" mb={4}>
        <Box>
          <Doctors />
        </Box>
        <Create patientId={patientId} />
      </Flex>
      <Table data={procedures}>
        <Table.Column dataKey="name" label="Procedure" />
        <Table.Column
          dataKey="startTime"
          label="Start Time"
          render={({ value, record }) => {
            if (value) {
              return <Text>{format(new Date(value), "h:mm aaaa")}</Text>;
            }
            return (
              <Button
                size="sm"
                onClick={() => {
                  handleTimer(new Date(), null, record._id || record.fakeId);
                }}
              >
                Start
              </Button>
            );
          }}
        />
        <Table.Column
          dataKey="endTime"
          label="End Time"
          render={({ value, record }) => {
            if (value) {
              return <Text>{format(new Date(value), "h:mm aaaa")}</Text>;
            }
            if (record.startTime && !record.endTime) {
              return (
                <Button
                  size="sm"
                  onClick={() => {
                    Modal.instance.open({
                      title: `Stop Timer for ${record.name}?`,
                      description: "Are you sure you want to stop a timer?",
                      okText: "Stop",
                      onOk() {
                        handleTimer(
                          null,
                          new Date(),
                          record._id || record.fakeId
                        );
                      }
                    });
                  }}
                >
                  End
                </Button>
              );
            }
            return <Text>-</Text>;
          }}
        />
        <Table.Column
          dataKey="totalTimeSeconds"
          label="Total Time"
          render={({ record }) => {
            return (
              <Timer startTime={record.startTime} endTime={record.endTime} />
            );
          }}
        />
      </Table>
    </Box>
  );
};

export default MonitoringBy;
